import { createAction, props } from '@ngrx/store';

export const setErrorModal = createAction('[boolean] Set Error Modal', props<{payload: boolean}>());
